import React, { useEffect, useState } from "react";
import { getProducts } from "../lib/api";
import { NewsletterForm } from "../components/NewsletterForm";
import { HomeHero } from "../components/home/HomeHero";
import { CollectionsSplit } from "../components/home/CollectionsSplit";
import { FeaturedEdit } from "../components/home/FeaturedEdit";
import { QuizBanner } from "../components/home/QuizBanner";
import { EditorialPromise } from "../components/home/EditorialPromise";

export default function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    getProducts().then(setProducts).catch(() => setProducts([]));
  }, []);

  const featured = products.slice(0, 4);

  return (
    <div className="bg-[#f0e9e1]" data-testid="home-page">
      <HomeHero />

      <section className="bg-[#1a1814] text-[#f0e9e1]" data-testid="founders-pricing-strip">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-6 sm:py-7 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-3 text-center sm:text-left">
          <div className="flex items-center gap-3">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#f0e9e1]" />
            <span className="micro-label text-[#f0e9e1]">Founders' Pricing · First 100 customers</span>
          </div>
          <div className="text-xs sm:text-sm italic text-[#f0e9e1]/75 max-w-md">
            Launch prices held for our first hundred. They won't return at this number.
          </div>
        </div>
      </section>

      <CollectionsSplit />
      <FeaturedEdit products={featured} />
      <QuizBanner />
      <EditorialPromise />

      <section className="bg-[#1a1814] text-[#f0e9e1]" data-testid="home-newsletter">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <div className="micro-label text-[#f0e9e1]/60 mb-5 sm:mb-6">Letters from the Atelier</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#f0e9e1] leading-tight max-w-lg">
              A correspondence cut to length. New drops, sizing notes and quiet field journals.
            </h2>
          </div>
          <div>
            <NewsletterForm variant="dark" />
            <p className="text-xs text-[#f0e9e1]/50 mt-4">We send once a fortnight. Unsubscribe gracefully at any time.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
